// Block handling of the one-canvas email template editor
// (components/TenantTemplateEditor.vue). Pure functions, no Vue and no DOM, so
// they can be checked under plain Node.
//
// The editor knows how to edit five block types. A template can hold others:
// the full vendor editor can add `content_library_block`, and a later version
// of the branding package may add more. Such a block must come back out of
// this editor exactly as it went in, so the editor shows it as a read-only
// row (no type picker, no fields) and these functions never look inside it.

// The types the editor has fields for, in the order its type picker lists them.
export const EDITABLE_BLOCK_TYPES = ['heading', 'markdown', 'image', 'divider', 'content'];

// The types its "add block" buttons offer.
export const ADDABLE_BLOCK_TYPES = ['heading', 'markdown', 'image', 'divider'];

/** Whether the editor has fields for this block's type. */
export function isEditableBlock(block) {
  return !!block && typeof block === 'object' && EDITABLE_BLOCK_TYPES.includes(block.type);
}

/**
 * The blocks as the editor holds them: each one a shallow copy with a `_key`
 * for the drag-and-drop list. Every other property is carried over untouched,
 * whatever the block's type.
 *
 * @param {Array<object>} blocks  as GET /branding/templates/{surface}/{slug} returns them
 * @param {function(): number} nextKey
 */
export function toEditorBlocks(blocks, nextKey) {
  return (Array.isArray(blocks) ? blocks : []).map((b) => ({ ...b, _key: nextKey() }));
}

/** The blocks as they are saved, previewed and sent: the editor's `_key` removed, nothing else. */
export function toPlainBlocks(blocks) {
  // eslint-disable-next-line no-unused-vars
  return (Array.isArray(blocks) ? blocks : []).map(({ _key, ...rest }) => rest);
}
